export enum BonusImages {
    FREE_BUY_BONUS_BUNDLE = 'free-buy-bonus-image-card-bundle.png',
    FREE_BUY_BONUS_MAIN = 'free-buy-bonus-image-card.png',
}
